import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const REMEMBER_FLAG = "heritage-admin-remembered";

export const rememberedOnThisDevice = () => localStorage.getItem(REMEMBER_FLAG) === "1";
export const setRemembered = (on) => (on ? localStorage.setItem(REMEMBER_FLAG, "1") : localStorage.removeItem(REMEMBER_FLAG));

let inflight = null;
/** Trades the httpOnly remember-me cookie for a fresh access token. Resolves to the token or null. */
export function refreshAdminToken() {
  if (!rememberedOnThisDevice()) return Promise.resolve(null);
  if (!inflight) {
    inflight = axios.post(`${API}/auth/refresh`, {}, { withCredentials: true })
      .then((r) => {
        localStorage.setItem("heritage-admin-token", r.data.token);
        if (r.data.name) localStorage.setItem("heritage-admin-name", r.data.name);
        if (r.data.email) localStorage.setItem("heritage-admin-email", r.data.email);
        return r.data.token;
      })
      .catch(() => { setRemembered(false); return null; })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export async function adminLogout() {
  try { await axios.post(`${API}/auth/logout`, {}, { withCredentials: true }); } catch { /* cookie may already be gone */ }
  ["heritage-admin-token", "heritage-admin-name", "heritage-admin-email"].forEach((k) => localStorage.removeItem(k));
  setRemembered(false);
}
